import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { ResumenResponse } from 'src/app/global/interfaces/resumen-response';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { ResumenServiceVM } from 'src/app/view-model/services/resumen-vm.service';
import { environment } from 'src/environments/environment';

// declaración de función que va a llamar a libreria Soicos.
declare function registrarConversion(orderID: any, total: any): any;
@Component({
  selector: 'app-seguimiento-producto',
  templateUrl: './seguimiento.component.html',
  styleUrls: ['./seguimiento.component.scss']
})
export class SeguimientoComponent implements OnInit {

  constructor(private resumenService: ResumenServiceVM, private snackBar: MatSnackBar,
    private tagManagerService: TagManagerService, private localStorageService: LocalStorageService,
    private carroService: CarroComprasService
  ) { }

  h: MatSnackBarHorizontalPosition = 'center';
  v: MatSnackBarVerticalPosition = 'top';

  dataResumen: ResumenResponse;
  loading: boolean;
  esRiesgoso: boolean;
  dataPaso3: Paso3;
  retraso: number = environment.getResumenDelay;

  ngOnInit() {
    this.loading = true;
    this.getResumen();
    this.esRiesgoso = false;
  }


  private getResumen() {

    const cbOK = (response: ResumenResponse) => {
      this.dataResumen = response;
      if (!this.dataResumen.data.estado) {
        setTimeout(() => {
          this.getResumen();
        }, this.retraso);
      } else {
        this.dataPaso3 = this.localStorageService.getPaso3();
        this.esRiesgoso = this.dataPaso3.siguientePaso === null ? true : false;
        this.loading = false;
        this.tagManagerService.logCierre(this.dataResumen.data.codigo);
        this.tagManagerService.logEvent(GoogleTagManager.eventPurchaseEventGTM().setCodigoPedido(this.dataResumen.data.codigo).setEtiqueta(this.carroService.getCurrentProduct().title).setIsPersonaNatural(this.localStorageService.getPaso1().currentIsPersonaNatural))
        // Aqui se llama a la funcion de marcaje asociada a Soicos.
        if (this.dataPaso3.soicos != undefined) {
          if (this.dataPaso3.soicos.isSoicos) {
            registrarConversion(this.dataResumen.data.codigo, this.dataPaso3.soicos.total);
          }
        }
      }

    };

    const cbError = error => {
      this.loading = false;
      console.error(error);
    };

    return this.resumenService.getResumen().subscribe(cbOK, cbError);
  }

  copiarCodigo(input: HTMLInputElement) {
    input.select();
    document.execCommand('copy');
    input.setSelectionRange(0, 0);
    this.openCopiado();
    // this.clipboard.writeText(this.dataResumen.data.codigo);

  }

  openCopiado(): void {
    this.snackBar.open('Código copiado', 'Cerrar', {
      horizontalPosition: this.h,
      verticalPosition: this.v,
      duration: 3000
    });
  }
}
